<template>
  <div>
    <div
      v-show="!edit"
      @mouseover="pencil = true"
      @mouseleave="pencil = false"
      class="header_column"
      v-on:dblclick="enableEditColumn"
    >
      <b class="color-grey-primary pointer">
        {{ column_name }}
        <font-awesome-icon
          class="dark_grey"
          @click="edit = true"
          v-show="pencil"
          icon="pencil-alt"
        />
      </b>
      <div class="nav menu_column nav-tabs right" style="border: none">
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            style="background-color: transparent !important; border: none"
          >
            <font-awesome-icon class="dark_grey" icon="ellipsis-v" />
          </a>
          <div class="dropdown-menu">
            <div
              v-if="selective_process.status != 1"
              @click="removeColumn"
              class="dropdown-item pointer"
            >
              Deletar coluna
            </div>
            <div @click="editFeedback" class="dropdown-item pointer">
              Editar Feedback
            </div>

            <!-- <div @click="addData" class="dropdown-item pointer">
              coletar dados
            </div> -->
          </div>
        </li>
      </div>

      <b
        v-show="!pencil"
        class="total_in_column radius-0"
        style="background-color: rgb(36, 26, 63) !important"
        >{{ total_in_column }}</b
      >
      <b
        v-show="selective_process.feedback"
        class="mr-1 total_in_column icon_kanban_blue"
      >
        <font-awesome-icon icon="video" />
      </b>
      <b
        v-show="(selective_process.field_mapping_ids || []).length > 0"
        class="mr-1 total_in_column icon_kanban_blue"
      >
        <font-awesome-icon icon="database" />
      </b>
    </div>
    <div v-show="edit">
      <input
        ref="column_name"
        type="text"
        class="form-control"
        v-on:keyup.enter="changeName"
        v-model="column_name"
      />
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import EditFeedback from "@/Recruiters/Kanban/EditFeedback.vue";
import FieldMappingIndex from "components/FieldMapping/Index.vue";
export default {
  components: {
    FieldMappingIndex,
  },
  props: [
    "selective_process",
    "total_in_column",
    "index",
    "gallery",
    "questions",
  ],
  data: () => ({
    edit: false,
    column_name: "",
    pencil: false,
  }),
  mounted() {
    this.column_name = this.selective_process.name;
  },
  methods: {
    addData() {
      this.$modal.show(
        FieldMappingIndex,
        {
          entity: "candidates",
          entity_data: {
            name: "selective_process_id",
            id: this.selective_process.id,
            field_data: this.selective_process,
          },
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    editFeedback() {
      this.$modal.show(
        EditFeedback,
        {
          selective_process: this.selective_process,
          gallery: this.gallery,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("setDraggable", true);
            eventBus.$emit("makeKanban", true);
          },
        }
      );
    },
    enableEditColumn() {
      this.edit = true;
      this.$refs.column_name.focus();
    },
    removeColumn() {
      if (this.total_in_column != 0) {
        this.$toast.error("Você não pode remover uma coluna com candidatos");
        return;
      }

      if (this.questions > 0) {
        this.$toast.error("Você não pode remover uma coluna com perguntas");
        return;
      }

      let conf = confirm("Tem certeza que deseja deletar essa coluna?");
      if (!conf) return;
      axios
        .delete(
          `/recruiters/jobs/${this.selective_process.job_id}/kanban/delete_column/${this.selective_process.id}`
        )
        .then((response) => {
          if (response.data.status) {
            eventBus.$emit("remove_column", this.index);
            this.$toast.success("Coluna Removida com sucesso");
            return;
          }
          this.$toast.error("Você não tem permissão para remover essa coluna");
          return;
        });
    },
    changeName() {
      this.$v.column_name.$touch();

      if (this.$v.column_name.$invalid) {
        this.$toast.error("Nome da coluna inválido");
        return;
      }

      axios
        .put(
          `/recruiters/jobs/${this.selective_process.job_id}/kanban/change_name_column`,
          {
            kanban: {
              column_name: this.column_name,
              selective_process_id: this.selective_process.id,
            },
          }
        )
        .then((response) => {
          this.edit = false;
        });
    },
  },
  validations: {
    column_name: { required, minLength: minLength(3) },
  },
};
</script>

<style>
</style>